import { render } from "./SelectableTableModal.vue?vue&type=template&id=fbae2452"
import script from "./SelectableTableModal.vue?vue&type=script&lang=js"
export * from "./SelectableTableModal.vue?vue&type=script&lang=js"

import "./SelectableTableModal.vue?vue&type=style&index=0&id=fbae2452&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QTable,QCard,QInnerLoading});
